import { useQuery } from "@apollo/client";
import { getCurriculumStandardSetsQuery } from "../modules/Queries";
import { useReduxState } from "SubjectStandardsV2/hooks/useReduxState";
import { useMemo } from "react";
import {
  getCurriculumIdAndType,
  getSetIdAndSetTypeFromState,
} from "SubjectStandardsV2/modules/reduxSelectors";
import _ from "lodash";
import { getDatasetsOrderByArgs } from "Datasets/modules/Utils";

const useCurriculumSets = params => {
  const { subjectIds, skip } = params || {};
  const {
    currentCurriculumProgramId,
    currentCurriculumProgramType,
  } = useReduxState(getCurriculumIdAndType);

  const { setId } = useReduxState(getSetIdAndSetTypeFromState);

  const { data, loading } = useQuery(getCurriculumStandardSetsQuery, {
    variables: {
      id: currentCurriculumProgramId,
      type: currentCurriculumProgramType,
      subjectIds,
      setId,
      ...getDatasetsOrderByArgs(),
    },
    fetchPolicy: "cache-and-network",
    context: {
      useHttpLink: true,
    },
    skip,
  });

  const standardEdges = useMemo(() => {
    const edges = _.map(
      data?.node?.plannerElementNodeSets?.edges || [],
      "node"
    );
    return _.map(edges, edge => {
      return {
        standardSet: _.omit(edge, "plannerElementNodeSetWrapperV2"),
        standards: _.map(
          edge?.plannerElementNodeSetWrapperV2?.publishedData?.edges || [],
          "node"
        ),
      };
    });
  }, [data]);

  const idsToPropertiesMap = useMemo(() => {
    return _.reduce(
      standardEdges,
      (acc, edge) => {
        const { standardSet = {}, standards = [] } = edge || {};

        acc[standardSet.id] = {
          ...standardSet,
          totalCount: _.size(standards),
          standards: _.map(standards, "id"),
        };
        return acc;
      },
      {}
    );
  }, [standardEdges]);

  return {
    showLoader: _.isEmpty(data) && loading,
    idsToPropertiesMap,
    standardEdges,
  };
};

export default useCurriculumSets;
